import { InitPort } from "./Definitions/MessageTypes";
const SW_BUNDLE_PATH = "./serviceworker.bundle.js";

export const installServiceWorker = async (
	owner: URL,
	port: MessagePort,
	cookiePort: MessagePort,
	initializationResponsePort: MessagePort
) => {
	if ("serviceWorker" in navigator) {
		await navigator.serviceWorker.register(SW_BUNDLE_PATH, { scope: "/" });
		const swReady = await navigator.serviceWorker.ready;
		const serviceWorker = swReady.active;
		serviceWorker.postMessage({ type: InitPort, owner: owner.toString() }, [
			port,
			cookiePort,
			initializationResponsePort,
		]);
	}
};
